import SparkMD5 from "spark-md5";
import {classifyFileTypes} from "./handleUpload";

import {getMetadata} from "video-metadata-thumbnails";


export const getHeaderLang = (lang) => {
    let Language = "en"
    if (lang === 'zh_CN') Language = "zh"
    if (lang === 'en_US') Language = "en"
    if (lang === 'ko_US') Language = "ko"
    if (lang === 'ja_US') Language = "ja"
    if (lang === 'hi_US') Language = "hi"
    if (lang === 'es_US') Language = "es"
    if (lang === 'pt_US') Language = "pt"
    if (lang === 'fr_US') Language = "fr"
    if (lang === 'de_US') Language = "de"
    if (lang === 'sv_US') Language = "sv"
    if (lang === 'pl_US') Language = "pl"
    return Language
}
// 专门处理你的扫码数据格式
export function isScanUrlSameAsCurrent(scanResult) {
    try {
        // 判断扫码结果中的URL是否包含 /sr? 路由
        // 因为扫码地址和当前页面地址可能不同，只要包含 /sr? 就认为是有效的
        if (!scanResult || typeof scanResult !== 'string') {
            return false
        }
        // 检查是否包含 /sr? 路由
        return scanResult.includes('/sr?')
    } catch {
        return false
    }
}
export function getFileSuffix(name) {
    let suffix = name.split(".")
    return suffix[suffix.length - 1]

}
export function calculateFileMd5(file,onProgress) {
    return new Promise((resolve, reject) => {
        // 如果已经计算过MD5，直接返回
        if (file.fileMd5) {
            if (onProgress) onProgress(100)
            resolve(file.fileMd5)
            return
        }

        let fileReader = new FileReader(),
            blobSlice = File.prototype.mozSlice || File.prototype.webkitSlice || File.prototype.slice,
            chunkSize = 2097152, // 2MB
            chunks = Math.ceil(file.size / chunkSize),
            currentChunk = 0,
            spark = new SparkMD5();

        fileReader.onload = (e) => {
            spark.appendBinary(e.target.result);
            currentChunk++;

            // 更新MD5计算进度（0-100%）
            if (onProgress) {
                const md5Progress = Math.floor((currentChunk / chunks) * 100)
                onProgress(md5Progress)
            }
            if (currentChunk < chunks) {
                loadNext();
            } else {
                file.fileMd5 = spark.end()
                file.totalChunks = Math.ceil(file.size / 6144000) // 6MB 分片大小

                resolve(file.fileMd5)
            }
        };

        fileReader.onerror = (err) => {
            reject(err)
        }

        function loadNext() {
            let start = currentChunk * chunkSize,
                end = start + chunkSize >= file.size ? file.size : start + chunkSize;
            fileReader.readAsBinaryString(blobSlice.call(file, start, end));
        }

        loadNext();
    })
}
// 检查文件大小是否符合类型限制
export function  checkFileSize(file) {

    const suffix = getFileSuffix(file.name)
    const type = '.' + suffix.toLowerCase()
    const fileType = classifyFileTypes(type)


    // 定义各类型文件大小限制（单位：字节）
    const sizeLimits = {
        image: 20 * 1024 * 1024,      // 20MB
        video: 4 * 1024 * 1024 * 1024, // 4GB
        audio: 20 * 1024 * 1024,       // 20MB
        doc: 100 * 1024 * 1024         // 100MB
    }

    if (fileType && sizeLimits[fileType]) {
        if (file.size > sizeLimits[fileType]) {

            return false
        }
    }

    return true
}

export function getImageDimensions(file) {
    return new Promise((resolve, reject) => {

        const img = new Image()
        const url = URL.createObjectURL(file)

        img.onload = function() {
            // 释放创建的Object URL，避免内存泄漏
            URL.revokeObjectURL(url)
            resolve({
                width: img.naturalWidth,
                height: img.naturalHeight
            })
        }
        img.onerror = function() {
            URL.revokeObjectURL(url)
            reject(new Error('图片加载失败'))
        }

        img.src = url
    })
}
export function getVideoDimensions(file) {
    return new Promise(async (resolve, ) => {
        try {
            // 获取视频的元数据
            const metadata = await getMetadata(file)
            resolve({
                width: metadata.width,
                height: metadata.height,
                duration: metadata.duration,
            })
        } catch  {
            resolve({
                width: 0,
                height: 0,
                duration: "",
            })
        }
    })
}